import { ComponentNameEnum, BaseButtonFieldConfig, ButtonWidthValueEnum, ButtonWidthCssValueEnum } from '@/types';

const getButtonWidthFieldConfig = (defaultValue = ButtonWidthValueEnum.AUTO): BaseButtonFieldConfig => ({
  componentName: ComponentNameEnum.BUTTON_GROUP,
  options: {
    [ButtonWidthValueEnum.AUTO]: {
      title: 'templateBuilder.fields.widthAuto',
      property: 'display',
      defaultValue,
    },
    [ButtonWidthValueEnum.FULL_WIDTH]: {
      title: 'templateBuilder.fields.fullWidth',
      property: 'display',
      defaultValue,
    },
  },
});

export const getDisplayButtonWidthFieldConfig = (defaultValue = ButtonWidthCssValueEnum.AUTO): BaseButtonFieldConfig => ({
  componentName: ComponentNameEnum.BUTTON_GROUP,
  options: {
    [ButtonWidthCssValueEnum.AUTO]: {
      title: 'templateBuilder.fields.widthAuto',
      property: 'width',
      defaultValue,
    },
    [ButtonWidthCssValueEnum.FULL_WIDTH]: {
      title: 'templateBuilder.fields.fullWidth',
      property: 'width',
      defaultValue,
    },
  },
});

export default getButtonWidthFieldConfig;
